import { useTranslation } from 'react-i18next'
import type { User } from '@dhl/keycloak-user-api'
import { Body1, Body2, Box, Card, Grid, H6 } from '@dhl-ui/components'

type Props = {
  user: User
}

export const DetailsCard = ({ user }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header title={t('admin.adminUsersPage.userForm.titleText')} />
      <Card.Content>
        <Grid>
          <H6>{t('admin.adminUsersPage.userForm.addTitleText')}</H6>
          <Box marginTop={1} gap={1}>
            <Body2 variant="tertiary">{t('admin.adminUsersPage.userForm.email')}</Body2>
            <Body1>{user.username}</Body1>
          </Box>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="stretch">
          <Grid size={{ xs: 6 }}>
            <Box marginTop={1} gap={1}>
              <Body2 variant="tertiary">{t('admin.adminUsersPage.userForm.firstName')}</Body2>
              <Body1>{user.firstName}</Body1>
            </Box>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Box marginTop={1} gap={1}>
              <Body2 variant="tertiary">{t('admin.adminUsersPage.userForm.lastName')}</Body2>
              <Body1>{user.lastName}</Body1>
            </Box>
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  )
}
